export const NEW_TAB_REL = "noreferrer noopener";
export const NEW_TAB_TARGET = "_blank";
export const NOFOLLOW_REL = "nofollow";
